
var modules_loaded = false;

if (app.isMobile) {
	$('html').addClass('mobile');
}
if (app.isTablet) {
	$('html').addClass('tablet');
}

$(document).ready(function($) {

	$('html').addClass('dom-loaded');

});

// ==== START GLOBAL RESIZE EVENTS ==== //
$(window).on('resize', function () {
	app.sizes = {
		viewporth: $(window).height(),
		realviewporth: window.innerHeight,
        viewportw: window.innerWidth
	};
});


